import { https , httpsFile } from './http.js';

export function index () {
    return https().get('material-group4');
}

export function getMatGrp4 (search,offset) {
    return https().get(`getMatGrp4?search=${search}&offset=${offset}`);
}